import { useEffect, useRef, useState } from "react";

export default function PhoneInput({
  countries = [],
  onChange,
  placeholder = "Mobile Number",
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (countries.length > 0) {
      const defaultCountry =
        countries.find((c) => c.dialCode === "+61") || countries[0];

      setSelected(defaultCountry);
    }
  }, [countries]);
  const [number, setNumber] = useState("");
  const [search, setSearch] = useState("");

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  // close on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // emit value
  useEffect(() => {
    if (onChange) {
      onChange({
        code: selected?.dialCode,
        number,
        full: `${selected?.dialCode}${number}`,
      });
    }
  }, [selected, number]);

  // filter countries
  const filteredCountries = countries.filter((c) => {
    const q = search.toLowerCase();
    return (
      c.code.toLowerCase().includes(q) || c.dialCode.toLowerCase().includes(q)
    );
  });

  return (
    <div ref={wrapperRef} className="relative w-full">
      {/* SINGLE FIELD */}
      <div className="flex h-11 w-full border border-gray-300 dark:border-[#4F4F4F] rounded-lg overflow-hidden focus-within:border-2 focus-within:border-black">
        {/* COUNTRY SELECT BUTTON */}
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="px-3 bg-gray-50 dark:bg-[#101010] text-sm font-medium flex items-center gap-1 border-r border-gray-300 dark:border-[#4F4F4F]"
        >
          {selected?.code} {selected?.dialCode}
          <span className="text-xs">▾</span>
        </button>

        {/* NUMBER INPUT */}
        <input
          ref={inputRef}
          type="tel"
          value={number}
          placeholder={placeholder}
          onChange={(e) => setNumber(e.target.value)}
          className="flex-1 px-3 text-base font-medium outline-none bg-white dark:text-white"
        />
      </div>

      {/* SEARCHABLE DROPDOWN */}
      {open && (
        <div className="absolute z-50 mt-2 w-72 bg-white dark:bg-[#101010] border border-gray-200 dark:border-[#4F4F4F] rounded-lg shadow-lg overflow-hidden">
          {/* SEARCH BOX */}
          <div className="p-2 border-b border-gray-200 dark:border-[#4F4F4F]">
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search country or code..."
              className="w-full h-9 px-3 text-sm border rounded-md outline-none
              focus:ring-2 focus:ring-blue-500 dark:bg-[#1a1a1a] dark:text-white"
            />
          </div>

          {/* LIST */}
          <div className="max-h-60 overflow-y-auto">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((c) => (
                <div
                  key={c.code}
                  onClick={() => {
                    setSelected(c);
                    setOpen(false);
                    setSearch("");
                  }}
                  className="px-3 py-2 cursor-pointer flex justify-between hover:bg-gray-100 dark:hover:bg-[#1f1f1f]"
                >
                  <span>{c.code}</span>
                  <span>{c.dialCode}</span>
                </div>
              ))
            ) : (
              <div className="p-3 text-sm text-gray-400">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}